import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Header from "../Components/Header";
import Sidebar from "../Components/Sidebar";
import key from "../config";
import {
  getSiteSettigs,
  addSiteSettigs,
  updateSiteSettigs,
} from "../actions/settings";
import { isEmpty, ObjectIsempty } from "../lib/isEmpty";
import toast from "react-hot-toast";

const initialFormValue = {
  siteName: "",
  address: "",
  sitelogo: "",
  contactNo: "",
  supportMail: "",
  socialLinks: [],
  volumeMiniThreshold: '',
  volumeMaxThreshold: "",
  priceChangeMiniThreshold: "",
  priceChangeMaxThreshold: '',
  liquidityMiniThreshold: "",
  liquidityMaxThreshold: "",
  volatilityThreshold: "",
  minCountTrendingPair: "",
  minCountSuggestedPair: "",
  volatilityMiniThreshold: "",
  volatilityMaxThreshold: ""
};

function SiteSettings() {
  const [count, setCount] = useState(1);
  const [settings, setSettings] = useState();

  const [formvalue, setFormvalue] = useState(initialFormValue);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    getSettings();
  }, []);

  const getSettings = async () => {
    try {
      let { status, message, result } = await getSiteSettigs();
      console.log('result--------', result)
      setFormvalue(result);
      setCount(result?.socialLinks?.length);
    } catch (err) {
      console.log(err, "errr");
    }
  };

  const validation = (value) => {
    try {
      let error = errors;
      if (isEmpty(value.siteName)) {
        error["siteName"] = "Field is required";
      } else {
        error["siteName"] = "";
      }
      if (isEmpty(value.address)) {
        error["address"] = "Field is required";
      } else {
        error["address"] = "";
      }
      if (isEmpty(value.contactNo)) {
        error["contactNo"] = "Field is required";
      } else {
        error["contactNo"] = "";
      }
      if (isEmpty(value.supportMail)) {
        error["supportMail"] = "Field is required";
      } else {
        error["supportMail"] = "";
      }
     if (isEmpty(value.faceBookLink)) {
        error["faceBookLink"] = "Field is required";
      } else {
        error["faceBookLink"] = "";
      }
      if (isEmpty(value.instagramLink)) {
        error["instagramLink"] = "Field is required";
      } else {
        error["instagramLink"] = "";
      }
      if (isEmpty(value.xLink)) {
        error["xLink"] = "Field is required";
      } else {
        error["xLink"] = "";
      }
      if (isEmpty(value.linkedInLink)) {
        error["linkedInLink"] = "Field is required";
      } else {
        error["linkedInLink"] = "";
      }
     
      return error;
    } catch (err) {
      console.log(err, "validation__err");
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    let Formvalue;
    if (name == "sitelogo") {
      Formvalue = { ...formvalue, [name]: event.target.files[0] };
    } else {
      Formvalue = { ...formvalue, [name]: value };
    }
    setFormvalue(Formvalue);
    // setErrors(validation(Formvalue));
  };

  const handleSocialLinks = async (e, index) => {
    try {
      const { name, value } = e.target;
      let arr = [...formvalue];
      let val = arr[index] ? arr[index] : {};
      if (name == "icon") {
        val[`${name}`] = e.target.files[0];
      } else {
        val[`${name}`] = value;
      }
      arr[index] = val;
      let Formvalue = { ...formvalue, ["socialLinks"]: arr };
      setFormvalue(Formvalue);
      // setErrors(validation(Formvalue));
    } catch (err) {
      console.log(err, "handleHighlights");
    }
  };

  const handleSubmit = async () => {
    try {
      // console.log('formvalue-----', formvalue)
      // Step 1: Validate input
      let isValidate = validation(formvalue);
      setErrors(isValidate);
      if (!ObjectIsempty(isValidate)) {
        return true;
      }

      // Step 2: Create plain JSON object instead of FormData
      const payload = {
        siteName: formvalue.siteName,
        address: formvalue.address,
        sitelogo: formvalue.sitelogo, // Optional: handle file upload separately if needed
        contactNo: formvalue.contactNo,
        supportMail: formvalue.supportMail,

        volumeMiniThreshold: formvalue.volumeMiniThreshold,
        volumeMaxThreshold: formvalue.volumeMaxThreshold,

        priceChangeMiniThreshold: formvalue.priceChangeMiniThreshold,
        priceChangeMaxThreshold: formvalue.priceChangeMaxThreshold,

        liquidityMiniThreshold: formvalue.liquidityMiniThreshold,
        liquidityMaxThreshold: formvalue.liquidityMaxThreshold,

        volatilityMiniThreshold: formvalue.volatilityMiniThreshold,
        volatilityMaxThreshold: formvalue.volatilityMaxThreshold,

        minCountTrendingPair: formvalue.minCountTrendingPair,
        minCountSuggestedPair: formvalue.minCountSuggestedPair,

        faceBookLink: formvalue.faceBookLink,
        instagramLink: formvalue.instagramLink,
        xLink: formvalue.xLink,
        linkedInLink: formvalue.linkedInLink,
      };
     
      // Step 3: Send JSON data instead of multipart/form-data
      const { status, message, result } = await updateSiteSettigs(payload);

      // Step 4: Handle response
      if (status === "success") {
        toast.success("Page Settings Updated");
        getSiteSettigs();
      } else {
        toast.error(message || "Something went wrong");
      }
    } catch (err) {
      console.error("handleSubmit__err", err);
    }
  };


  return (
    <>
      <Container fluid className="common_bg position-relative">
        <div className="liner"></div>
        <Row>
          <Col xl={2} lg={0} className="p-0 d-none d-xl-block">
            <Sidebar />
          </Col>
          <Col xl={10} lg={12}>
            <Header title={"Site Settings"} />
            <div className="common_page_scroller">
              <div className="mt-3 mt-sm-5 profile_holder">
                <Row className="align-items-center">
                  {/* <Col lg={7} className="mb-3 mb-lg-4">
                    <div className="rp_singleinput_holder">
                      <p className="rp_label mb-2">Site Logo</p>
                      <label
                        for="file-upload"
                        className="custom-file-upload mt-3">
                        Custom Upload
                      </label>
                      <input
                        id="file-upload"
                        type="file"
                        onChange={(e) => {
                          handleChange(e);
                        }}
                        name="sitelogo"
                        className="hide_input"
                      />
                      <Row className="mt-3">
                        <Col lg={3}>
                          <img
                            className="img-fluid cmn__siteLogo"
                            src={
                              typeof formvalue?.sitelogo == "string"
                                ? API_URL +
                                  "/public/images/" +
                                  formvalue?.sitelogo
                                : URL.createObjectURL(formvalue?.sitelogo)
                            }
                          />
                        </Col>
                      </Row>
                    </div>
                  </Col> */}
                  <Col lg={7} className="mb-3 mb-lg-4">
                    <div className="rp_singleinput_holder">
                      <p className="rp_label mb-2">Site Name</p>
                      <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                        <input
                          type="text"
                          placeholder="Site Name"
                          name="siteName"
                          value={formvalue?.siteName}
                          onChange={handleChange}
                          className="rp_singleInput flex-grow-1"
                        />
                      </div>
                    </div>
                  </Col>

                  <Col lg={7} className="mb-3 mb-lg-4">
                    <div className="rp_singleinput_holder">
                      <p className="rp_label mb-2">Address</p>
                      <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                        <input
                          type="text"
                          placeholder="Site Name"
                          name="address"
                          value={formvalue?.address}
                          onChange={handleChange}
                          className="rp_singleInput flex-grow-1"
                        />
                      </div>
                    </div>
                  </Col>

                  <Col lg={7} className="mb-3 mb-lg-4">
                    <div className="rp_singleinput_holder">
                      <p className="rp_label mb-2">Contact No</p>
                      <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                        <input
                          type="text"
                          placeholder="Site Name"
                          name="contactNo"
                          value={formvalue?.contactNo}
                          onChange={handleChange}
                          className="rp_singleInput flex-grow-1"
                        />
                      </div>
                    </div>
                  </Col>

                  <Col lg={7} className="mb-3 mb-lg-4">
                    <div className="rp_singleinput_holder">
                      <p className="rp_label mb-2">Support Mail</p>
                      <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                        <input
                          type="text"
                          placeholder="Site Name"
                          name="supportMail"
                          value={formvalue?.supportMail}
                          onChange={handleChange}
                          className="rp_singleInput flex-grow-1"
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row className="align-items-center">
                  <Col lg={7} className="mb-3 mb-lg-4">
                    <div className="rp_singleinput_holder">
                      <p className="rp_label mb-2">Volume Mini Threshold</p>
                      <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                        <input
                          type="number"
                          name="volumeMiniThreshold"
                          placeholder="Volume Mini Threshold"
                          className="rp_singleInput flex-grow-1"
                          value={formvalue?.volumeMiniThreshold}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row className="align-items-center">
                  <Col lg={7} className="mb-3 mb-lg-4">
                    <div className="rp_singleinput_holder">
                      <p className="rp_label mb-2">Volume Max Threshold</p>
                      <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                        <input
                          type="number"
                          name="volumeMaxThreshold"
                          placeholder="Volume Max Threshold"
                          className="rp_singleInput flex-grow-1"
                          value={formvalue?.volumeMaxThreshold}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row className="align-items-center">
                  <Col lg={7} className="mb-3 mb-lg-4">
                    <div className="rp_singleinput_holder">
                      <p className="rp_label mb-2">Price Mini Threshold</p>
                      <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                        <input
                          type="number"
                          name="priceChangeMiniThreshold"
                          placeholder="Price Mini Threshold"
                          className="rp_singleInput flex-grow-1"
                          value={formvalue?.priceChangeMiniThreshold}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row className="align-items-center">
                  <Col lg={7} className="mb-3 mb-lg-4">
                    <div className="rp_singleinput_holder">
                      <p className="rp_label mb-2">Price Max Threshold</p>
                      <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                        <input
                          type="number"
                          name="priceChangeMaxThreshold"
                          placeholder="Price Change Threshold"
                          className="rp_singleInput flex-grow-1"
                          value={formvalue?.priceChangeMaxThreshold}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row className="align-items-center">
                  <Col lg={7} className="mb-3 mb-lg-4">
                    <div className="rp_singleinput_holder">
                      <p className="rp_label mb-2">Liquidity Mini Threshold</p>
                      <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                        <input
                          type="number"
                          name="liquidityMiniThreshold"
                          placeholder="Liquidity Threshold"
                          className="rp_singleInput flex-grow-1"
                          value={formvalue?.liquidityMiniThreshold}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row className="align-items-center">
                  <Col lg={7} className="mb-3 mb-lg-4">
                    <div className="rp_singleinput_holder">
                      <p className="rp_label mb-2">Liquidity Max Threshold</p>
                      <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                        <input
                          type="number"
                          name="liquidityMaxThreshold"
                          placeholder="Liquidity Threshold"
                          className="rp_singleInput flex-grow-1"
                          value={formvalue?.liquidityMaxThreshold}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row className="align-items-center">
                  <Col lg={7} className="mb-3 mb-lg-4">
                    <div className="rp_singleinput_holder">
                      <p className="rp_label mb-2">Volatility Mini Threshold</p>
                      <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                        <input
                          type="number"
                          name="volatilityMiniThreshold"
                          placeholder="Volatility"
                          className="rp_singleInput flex-grow-1"
                          value={formvalue?.volatilityMiniThreshold}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row className="align-items-center">
                  <Col lg={7} className="mb-3 mb-lg-4">
                    <div className="rp_singleinput_holder">
                      <p className="rp_label mb-2">Volatility Max Threshold</p>
                      <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                        <input
                          type="number"
                          name="volatilityMaxThreshold"
                          placeholder="Volatility"
                          className="rp_singleInput flex-grow-1"
                          value={formvalue?.volatilityMaxThreshold}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>

                <Row className="align-items-center">
                  <Col lg={7} className="mb-3 mb-lg-4">
                    <div className="rp_singleinput_holder">
                      <p className="rp_label mb-2">Min Count Trending Pair</p>
                      <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                        <input
                          type="number"
                          name="minCountTrendingPair"
                          placeholder="Max Count Trending Pair"
                          className="rp_singleInput flex-grow-1"
                          value={formvalue?.minCountTrendingPair}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                <Row className="align-items-center">
                  <Col lg={7} className="mb-3 mb-lg-4">
                    <div className="rp_singleinput_holder">
                      <p className="rp_label mb-2">Min Count Suggested Pair</p>
                      <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                        <input
                          type="number"
                          name="minCountSuggestedPair"
                          placeholder="Max Count Suggested Pair"
                          className="rp_singleInput flex-grow-1"
                          value={formvalue?.minCountSuggestedPair}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
                {/* <Row className="align-items-center">
                  <Col lg={7} className="mb-2 mb-lg-2">
                    <div className="rp_singleinput_holder">
                      <p className="rp_label mb-2 rp_lable_theme">
                        Social Media Links
                      </p>
                    </div>
                  </Col>
                </Row> */}

                <>
                  {/* Facebook */}
                  {/* <Row className="align-items-center">
                    <Col lg={7} className="mb-3 mb-lg-4">
                      <div className="rp_singleinput_holder">
                        <p className="rp_label mb-2">Facebook Name</p>
                        <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                          <input
                            type="text"
                            placeholder="Facebook Name"
                            name="facebookName"
                            value={formvalue?.socialLinks?.facebookName || ""}
                            className="rp_singleInput flex-grow-1"
                            onChange={(e) => handleSocialLinks(e, "facebookName")}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row> */}
                  <Row className="align-items-center">
                    <Col lg={7} className="mb-3 mb-lg-4">
                      <div className="rp_singleinput_holder">
                        <p className="rp_label mb-2">Facebook Link</p>
                        <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                          <input
                            type="text"
                            placeholder="Facebook Link"
                            name="faceBookLink"
                            value={formvalue?.faceBookLink || ""}
                            className="rp_singleInput flex-grow-1"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  {/* Instagram */}
                  {/* <Row className="align-items-center">
                    <Col lg={7} className="mb-3 mb-lg-4">
                      <div className="rp_singleinput_holder">
                        <p className="rp_label mb-2">Instagram Name</p>
                        <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                          <input
                            type="text"
                            placeholder="Instagram Name"
                            name="instagramName"
                            value={formvalue?.socialLinks?.instagramName || ""}
                            className="rp_singleInput flex-grow-1"
                            onChange={(e) => handleSocialLinks(e, "instagramName")}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row> */}
                  <Row className="align-items-center">
                    <Col lg={7} className="mb-3 mb-lg-4">
                      <div className="rp_singleinput_holder">
                        <p className="rp_label mb-2">Instagram Link</p>
                        <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                          <input
                            type="text"
                            placeholder="Instagram Link"
                            name="instagramLink"
                            value={formvalue?.instagramLink || ""}
                            className="rp_singleInput flex-grow-1"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  {/* X (Twitter) */}
                  {/* <Row className="align-items-center">
                    <Col lg={7} className="mb-3 mb-lg-4">
                      <div className="rp_singleinput_holder">
                        <p className="rp_label mb-2">X (Twitter) Name</p>
                        <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                          <input
                            type="text"
                            placeholder="X (Twitter) Name"
                            name="xName"
                            value={formvalue?.socialLinks?.xName || ""}
                            className="rp_singleInput flex-grow-1"
                            onChange={(e) => handleSocialLinks(e, "xName")}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row> */}
                  <Row className="align-items-center">
                    <Col lg={7} className="mb-3 mb-lg-4">
                      <div className="rp_singleinput_holder">
                        <p className="rp_label mb-2">X (Twitter) Link</p>
                        <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                          <input
                            type="text"
                            placeholder="X (Twitter) Link"
                            name="xLink"
                            value={formvalue?.xLink || ""}
                            className="rp_singleInput flex-grow-1"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>

                  {/* LinkedIn */}
                  {/* <Row className="align-items-center">
                    <Col lg={7} className="mb-3 mb-lg-4">
                      <div className="rp_singleinput_holder">
                        <p className="rp_label mb-2">LinkedIn Name</p>
                        <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                          <input
                            type="text"
                            placeholder="LinkedIn Name"
                            name="linkedInName"
                            value={formvalue?.socialLinks?.linkedInName || ""}
                            className="rp_singleInput flex-grow-1"
                            onChange={(e) => handleSocialLinks(e, "linkedInName")}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row> */}
                  <Row className="align-items-center">
                    <Col lg={7} className="mb-3 mb-lg-4">
                      <div className="rp_singleinput_holder">
                        <p className="rp_label mb-2">LinkedIn Link</p>
                        <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                          <input
                            type="text"
                            placeholder="LinkedIn Link"
                            name="linkedInLink"
                            value={formvalue?.linkedInLink || ""}
                            className="rp_singleInput flex-grow-1"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </Col>
                  </Row>
                </>


                {/* {[...Array(count)].map((item, index) => {
                  let i = index;
                  return (
                    <>
                      <Row className="align-items-center">
                        <Col lg={7} className="mb-3 mb-lg-4">
                          <div className="rp_singleinput_holder">
                            <p className="rp_label mb-2">Name</p>
                            <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                              <input
                                type="text"
                                placeholder="Social Name"
                                name="name"
                                value={formvalue?.socialLinks[index]?.name}
                                className="rp_singleInput flex-grow-1"
                                onChange={(e) => {
                                  handleSocialLinks(e, i);
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <Row className="align-items-center">
                        <Col lg={7} className="mb-3 mb-lg-4">
                          <div className="rp_singleinput_holder">
                            <p className="rp_label mb-2">Link</p>
                            <div className="rp_input_holder rounded-2 py-2 px-3 d-flex justify-content-start align-items-center gap-2">
                              <input
                                type="text"
                                name="link"
                                value={formvalue?.socialLinks[index]?.link}
                                placeholder="Social Link"
                                className="rp_singleInput flex-grow-1"
                                onChange={(e) => {
                                  handleSocialLinks(e, i);
                                }}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>

                      <Row className="align-items-center">
                        <Col lg={7} className="mb-3 mb-lg-4">
                          <div className="rp_singleinput_holder">
                            <p className="rp_label mb-2">Social Logo</p>
                            <label
                              for={`file-upload${i}`}
                              className="custom-file-upload mt-3">
                              Custom Upload
                            </label>
                            <input
                              id={`file-upload${i}`}
                              type="file"
                              onChange={(e) => {
                                handleSocialLinks(e, i);
                              }}
                              name="icon"
                              className="hide_input"
                            />
                          </div>
                          <Row className="mt-3">
                            <Col lg={3}>
                              <img
                                className="img-fluid cmn__siteLogo"
                                src={
                                  // API_URL +
                                  // "/public/images/" +
                                  // formvalue?.socialLinks[index]?.icon

                                  formvalue?.socialLinks?.length > 0 &&
                                    typeof formvalue?.socialLinks[index]?.icon ==
                                    "string"
                                    ? key.BACKEND_URL +
                                    "/public/images/" +
                                    formvalue?.socialLinks[index]?.icon
                                    : typeof formvalue?.socialLinks[index]
                                      ?.icon == "undefined"
                                      ? ""
                                      : URL.createObjectURL(
                                        formvalue?.socialLinks[index]?.icon
                                      )
                                }
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </>
                  );
                })} */}
                {/* 
                <Row className="align-items-center">
                  <Col lg={5} className="mb-4">
                    <div className="rp_singleinput_holder">
                      <button
                        className="orange_small_primary mt-4"
                        onClick={() => {
                          setCount(count + 1);
                        }}>
                        Add
                      </button>
                      <button
                        className="orange_small_secondary mt-4 ms-3"
                        disabled={count == 1 ? "disabled" : ""}
                        onClick={() => {
                          setCount(count - 1);
                        }}>
                        Delete
                      </button>
                    </div>
                  </Col>
                </Row> */}

                <div className="d-flex gap-3 mb-3">
                  <button className="secondary_btn">Cancel</button>
                  <button
                    className="orange_primary_btn"
                    onClick={() => {
                      handleSubmit();
                    }}>
                    Save
                  </button>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default SiteSettings;
